export default "__VITE_ASSET__igM3kCB2__"